import React from 'react'
import EssLayout from '../../../../layout/components/ESSLayout'
import EssAttendance from '../components/EssAttendance'
import ESSPunchList from '../components/ESSPunchList'
import ESSLeaveRequest from '../components/ESSLeaveRequest'

function EssAttendancePage() {
  return (
    <EssLayout>
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-6'>
                  <ESSPunchList/>
                </div>
                <div className='col-md-6'>
                    <EssAttendance />
                    <ESSLeaveRequest />
                </div>
                <div className='col-md-6'></div>
                <div className='col-md-6'>
                  
                </div>
            </div>
        </div>
    </EssLayout>
  )
}

export default EssAttendancePage